import { checkoutIdRegex, MODULE_CORE, outerModuleList, VERSION_1, versionRegex } from '../constants';
import { TComgateCheckoutConfigBase } from '../types';

/**
 * Check Comgate Checkout load configuration.
 * @param config
 */
export function baseConfigValidator(config: TComgateCheckoutConfigBase): string | true {
    if (!window) {
        return 'Window object is not available. Please ensure you are running this in a valid browser environment.';
    }

    if (typeof window !== 'object') {
        return 'Invalid window type. An object is expected. Please ensure you are running this in a valid browser environment.';
    }

    // Check if config is an object.
    if (!config || typeof config !== 'object') {
        return 'Config: Invalid type. An object is expected.';
    }

    // Get more console outputs
    if ('debug' in config && typeof config.debug !== 'boolean') {
        return 'Config: Invalid debug value. Boolean expected.';
    }

    // Check if checkoutId is a string and matches the UUID v4 format.
    if (!config.checkoutId || typeof config.checkoutId! !== 'string' || !checkoutIdRegex.test(config.checkoutId)) {
        return 'Config: Invalid checkoutId format. UUIDv4 expected.';
    }

    // Check if config.timeout is a number or undefined
    if ('timeout' in config && !Number.isInteger(config.timeout)) {
        return 'Config: Invalid timeout value. A number in milliseconds is expected.';
    }

    // Get major with fallback to default and validate major.
    if ('version' in config && (!config.version || typeof config.version !== 'string' || !versionRegex.test(config.version))) {
        return `Config: Invalid version value '${config.version}'. Allowed values: ${versionRegex.toString()}`;
    }

    // Let version @1 die
    if (config.version && config.version === VERSION_1) {
        return 'Config: Please upgrade to the latest version. Version 1 is no longer supported.';
    }

    // Validate module list
    if (!('modules' in config) || !Array.isArray(config.modules)) {
        return `Config: The "modules" property must be provided as an array. Allowed values: ${outerModuleList.join(', ')}.`;
    }

    // At least one module is required (excluding core).
    if (config.modules.length === 0 || (config.modules.length === 1 && config.modules.includes(MODULE_CORE))) {
        return `Config: No modules have been provided. At least one module is required (excluding core). Allowed values: ${outerModuleList.join(', ')}.`;
    }

    // Verify that all defined values are valid modules.
    const invalid = config.modules.find((m) => !outerModuleList.includes(m));
    if (invalid !== undefined) {
        return `Config: Invalid module value '${invalid}'. Allowed values: ${outerModuleList.join(', ')}.`;
    }

    // // Get major with fallback to default and validate major.
    // if ('baseUrl' in config && (!config.baseUrl || !baseUrlRegex.test(config.baseUrl))) {
    //     return `Config: Invalid baseUrl format '${config.baseUrl}'. Allowed values: ${baseUrlRegex.toString()}`;
    // }

    return true;
}
